import { Link } from 'react-router';
import { useT } from '@/i18n/context';
import { Page } from '@/ui/Page';

export function NotFoundRoute() {
  const t = useT();

  return (
    <Page title={t('ui.error.not_found_title')}>
      <p className="text-fg-muted" style={{ fontSize: 'var(--text-action)' }}>
        {t('ui.error.not_found_body')}
      </p>
      <Link
        to="/"
        className="border-border text-fg-muted hover:border-accent hover:text-accent w-fit border px-4 py-2 font-mono transition-colors"
        style={{ fontSize: 'var(--text-action)' }}
      >
        {t('ui.error.back_to_start')}
      </Link>
    </Page>
  );
}
